module.exports = __webpack_public_path__ + "static/media/main idea.fa1663eb.mp3";